<div #csClockTimePicker class="input-group clockpicker" style="width:99px">
  <input #inputfield type="text" class="form-control"  (blur)="onInputBlur($event)" (input)="onUserInput($event)"
                     [required]="required" [pattern]="pattern" [disabled]="disabled" placeholder="hh:mm" style="width:60px"
                     [ngStyle]="{'opacity' : disabled ? '0.5':'1'}">
  <span class="input-group-addon" [ngStyle]="{'pointer-events' : disabled ?  'none' : 'auto', 'opacity' : disabled ? '0.5':'1'}">
      <span class="glyphicon glyphicon-time"></span>
  </span>
</div>